import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Fancybox2 from "../components/Fancybox2";
import Slider from "react-slick";
import avengerCakeGalleySliderImageZeppoli from "../assets/img/GallerySliderImages/avengerCakeGalleySliderImageZeppoli.webp";
import birthdayCakeGalleySliderImageZeppoli from "../assets/img/GallerySliderImages/birthdayCakeGalleySliderImageZeppoli.webp";
import cupCakeGalleySliderImageZeppoli from "../assets/img/GallerySliderImages/cupCakeGalleySliderImageZeppoli.webp";
import engagementCakeGalleySliderImageZeppoli from "../assets/img/GallerySliderImages/engagementCakeGalleySliderImageZeppoli.webp";
import engagementFourCakeGalleySliderImageZeppoli from "../assets/img/GallerySliderImages/engagementFourCakeGalleySliderImageZeppoli.webp";
import engagementThreeCakeGalleySliderImageZeppoli from "../assets/img/GallerySliderImages/engagementThreeCakeGalleySliderImageZeppoli.webp";
import engagementTwoCakeGalleySliderImageZeppoli from "../assets/img/GallerySliderImages/engagementTwoCakeGalleySliderImageZeppoli.webp";
import jungleCakeGalleySliderImageZeppoli from "../assets/img/GallerySliderImages/jungleCakeGalleySliderImageZeppoli.webp";
import marineCakeGalleySliderImageZeppoli from "../assets/img/GallerySliderImages/marineCakeGalleySliderImageZeppoli.webp";
import mermaidCakeGalleySliderImageZeppoli from "../assets/img/GallerySliderImages/mermaidCakeGalleySliderImageZeppoli.webp";
import pandaCakeGalleySliderImageZeppoli from "../assets/img/GallerySliderImages/pandaCakeGalleySliderImageZeppoli.webp";
import specialCakeGalleySliderImageZeppoli from "../assets/img/GallerySliderImages/specialCakeGalleySliderImageZeppoli.webp";
import winterCakeGalleySliderImageZeppoli from "../assets/img/GallerySliderImages/winterCakeGalleySliderImageZeppoli.webp";
import winterTwoCakeGalleySliderImageZeppoli from "../assets/img/GallerySliderImages/winterTwoCakeGalleySliderImageZeppoli.webp";

function GallerySlider() {
  // for fancy box
  const opts = {
    fullScreen: {
      autoStart: true, // Auto-start in full-screen mode
    },
    Thumbs: false,
    // Other options...
  };

  const [isLoaded, setIsLoaded] = useState(false);
  // for animation begin
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [isVisible, setIsVisible] = useState(false);

  const directorsSliderSettings = {
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    // Set a timeout to change the visibility after 3 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    // Cleanup timeout if the component unmounts
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    window.addEventListener("load", function () {
      setIsLoaded(true);
    });
  }, [isLoaded]);

  return (
    <>
      <section className="space-top">
        <div className="container">
          <div className="title-area text-center" data-aos="fade-up">
            <span className="sub-title">Gallery</span>
            <h2 className="sec-title">Our Foods Gallery</h2>
            <p className="sec-text ms-auto me-auto">
              {" "}
              Each image captures the essence of our commitment to quality,
              precision, and the art of indulgence.
            </p>
          </div>

          <div className="px-lg-4 px-3 my-5" data-aos="fade-up">
            <Fancybox2 options={opts}>
              <Slider
                {...directorsSliderSettings}
                className="row th-carousel"
                data-slide-show="4"
                data-arrows="true"
                // dots={false}
                // infinite={true}
                // speed={500}
                // slidesToShow={4}
                // slidesToScroll={1}
                // autoplay={true}
                // autoplaySpeed={1000}
                // arrows={false}
              >
                <div>
                  <div className="gallery-card mx-2">
                    <div
                      className="gallery-img"
                      style={{ borderRadius: "12px" }}
                    >
                      <img
                        src={avengerCakeGalleySliderImageZeppoli}
                        alt="Zeppoli gallery image"
                        className="w-100 h-100"
                        loading="lazy"
                      />
                    </div>
                    <div
                      className="gallery-content"
                      style={{ borderRadius: "12px" }}
                    >
                      <a
                        data-fancybox="gallery2"
                        href={avengerCakeGalleySliderImageZeppoli}
                        className="icon-btn popup-img"
                        name="Zeppoli gallery image"
                      >
                        <i className="fas fa-eye"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="gallery-card mx-2">
                    <div
                      className="gallery-img"
                      style={{ borderRadius: "12px" }}
                    >
                      <img
                        src={birthdayCakeGalleySliderImageZeppoli}
                        alt="Zeppoli gallery image"
                        className="w-100 h-100"
                        loading="lazy"
                      />
                    </div>
                    <div
                      className="gallery-content"
                      style={{ borderRadius: "12px" }}
                    >
                      <a
                        data-fancybox="gallery2"
                        href={birthdayCakeGalleySliderImageZeppoli}
                        className="icon-btn popup-img"
                        name="Zeppoli gallery image"
                      >
                        <i className="fas fa-eye"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="gallery-card mx-2">
                    <div
                      className="gallery-img"
                      style={{ borderRadius: "12px" }}
                    >
                      <img
                        src={cupCakeGalleySliderImageZeppoli}
                        alt="Zeppoli gallery image"
                        className="w-100 h-100"
                        loading="lazy"
                      />
                    </div>
                    <div
                      className="gallery-content"
                      style={{ borderRadius: "12px" }}
                    >
                      <a
                        data-fancybox="gallery2"
                        href={cupCakeGalleySliderImageZeppoli}
                        className="icon-btn popup-img"
                        name="Zeppoli gallery image"
                      >
                        <i className="fas fa-eye"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="gallery-card mx-2">
                    <div
                      className="gallery-img"
                      style={{ borderRadius: "12px" }}
                    >
                      <img
                        src={engagementCakeGalleySliderImageZeppoli}
                        alt="Zeppoli gallery image"
                        className="w-100 h-100"
                        loading="lazy"
                      />
                    </div>
                    <div
                      className="gallery-content"
                      style={{ borderRadius: "12px" }}
                    >
                      <a
                        data-fancybox="gallery2"
                        href={engagementCakeGalleySliderImageZeppoli}
                        className="icon-btn popup-img"
                        name="Zeppoli gallery image"
                      >
                        <i className="fas fa-eye"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="gallery-card mx-2">
                    <div
                      className="gallery-img"
                      style={{ borderRadius: "12px" }}
                    >
                      <img
                        src={jungleCakeGalleySliderImageZeppoli}
                        alt="Zeppoli gallery image"
                        className="w-100 h-100"
                        loading="lazy"
                      />
                    </div>
                    <div
                      className="gallery-content"
                      style={{ borderRadius: "12px" }}
                    >
                      <a
                        data-fancybox="gallery2"
                        href={jungleCakeGalleySliderImageZeppoli}
                        className="icon-btn popup-img"
                        name="Zeppoli gallery image"
                      >
                        <i className="fas fa-eye"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="gallery-card mx-2">
                    <div
                      className="gallery-img"
                      style={{ borderRadius: "12px" }}
                    >
                      <img
                        src={marineCakeGalleySliderImageZeppoli}
                        alt="Zeppoli gallery image"
                        className="w-100 h-100"
                        loading="lazy"
                      />
                    </div>
                    <div
                      className="gallery-content"
                      style={{ borderRadius: "12px" }}
                    >
                      <a
                        data-fancybox="gallery2"
                        href={marineCakeGalleySliderImageZeppoli}
                        className="icon-btn popup-img"
                        name="Zeppoli gallery image"
                      >
                        <i className="fas fa-eye"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="gallery-card mx-2">
                    <div
                      className="gallery-img"
                      style={{ borderRadius: "12px" }}
                    >
                      <img
                        src={mermaidCakeGalleySliderImageZeppoli}
                        alt="Zeppoli gallery image"
                        className="w-100 h-100"
                        loading="lazy"
                      />
                    </div>
                    <div
                      className="gallery-content"
                      style={{ borderRadius: "12px" }}
                    >
                      <a
                        data-fancybox="gallery2"
                        href={mermaidCakeGalleySliderImageZeppoli}
                        className="icon-btn popup-img"
                        name="Zeppoli gallery image"
                      >
                        <i className="fas fa-eye"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="gallery-card mx-2">
                    <div
                      className="gallery-img"
                      style={{ borderRadius: "12px" }}
                    >
                      <img
                        src={engagementFourCakeGalleySliderImageZeppoli}
                        alt="Zeppoli gallery image"
                        className="w-100 h-100"
                        loading="lazy"
                      />
                    </div>
                    <div
                      className="gallery-content"
                      style={{ borderRadius: "12px" }}
                    >
                      <a
                        data-fancybox="gallery2"
                        href={engagementFourCakeGalleySliderImageZeppoli}
                        className="icon-btn popup-img"
                        name="Zeppoli gallery image"
                      >
                        <i className="fas fa-eye"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="gallery-card mx-2">
                    <div
                      className="gallery-img"
                      style={{ borderRadius: "12px" }}
                    >
                      <img
                        src={pandaCakeGalleySliderImageZeppoli}
                        alt="Zeppoli gallery image"
                        className="w-100 h-100"
                        loading="lazy"
                      />
                    </div>
                    <div
                      className="gallery-content"
                      style={{ borderRadius: "12px" }}
                    >
                      <a
                        data-fancybox="gallery2"
                        href={pandaCakeGalleySliderImageZeppoli}
                        className="icon-btn popup-img"
                        name="Zeppoli gallery image"
                      >
                        <i className="fas fa-eye"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="gallery-card mx-2">
                    <div
                      className="gallery-img"
                      style={{ borderRadius: "12px" }}
                    >
                      <img
                        src={winterCakeGalleySliderImageZeppoli}
                        alt="Zeppoli gallery image"
                        className="w-100 h-100"
                        loading="lazy"
                      />
                    </div>
                    <div
                      className="gallery-content"
                      style={{ borderRadius: "12px" }}
                    >
                      <a
                        data-fancybox="gallery2"
                        href={winterCakeGalleySliderImageZeppoli}
                        className="icon-btn popup-img"
                        name="Zeppoli gallery image"
                      >
                        <i className="fas fa-eye"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="gallery-card mx-2">
                    <div
                      className="gallery-img"
                      style={{ borderRadius: "12px" }}
                    >
                      <img
                        src={specialCakeGalleySliderImageZeppoli}
                        alt="Zeppoli gallery image"
                        className="w-100 h-100"
                        loading="lazy"
                      />
                    </div>
                    <div
                      className="gallery-content"
                      style={{ borderRadius: "12px" }}
                    >
                      <a
                        data-fancybox="gallery2"
                        href={specialCakeGalleySliderImageZeppoli}
                        className="icon-btn popup-img"
                        name="Zeppoli gallery image"
                      >
                        <i className="fas fa-eye"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="gallery-card mx-2">
                    <div
                      className="gallery-img"
                      style={{ borderRadius: "12px" }}
                    >
                      <img
                        src={avengerCakeGalleySliderImageZeppoli}
                        alt="Zeppoli gallery image"
                        className="w-100 h-100"
                        loading="lazy"
                      />
                    </div>
                    <div
                      className="gallery-content"
                      style={{ borderRadius: "12px" }}
                    >
                      <a
                        data-fancybox="gallery2"
                        href={avengerCakeGalleySliderImageZeppoli}
                        className="icon-btn popup-img"
                        name="Zeppoli gallery image"
                      >
                        <i className="fas fa-eye"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="gallery-card mx-2">
                    <div
                      className="gallery-img"
                      style={{ borderRadius: "12px" }}
                    >
                      <img
                        src={engagementTwoCakeGalleySliderImageZeppoli}
                        alt="Zeppoli gallery image"
                        className="w-100 h-100"
                        loading="lazy"
                      />
                    </div>
                    <div
                      className="gallery-content"
                      style={{ borderRadius: "12px" }}
                    >
                      <a
                        data-fancybox="gallery2"
                        href={engagementTwoCakeGalleySliderImageZeppoli}
                        className="icon-btn popup-img"
                        name="Zeppoli gallery image"
                      >
                        <i className="fas fa-eye"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="gallery-card mx-2">
                    <div
                      className="gallery-img"
                      style={{ borderRadius: "12px" }}
                    >
                      <img
                        src={winterTwoCakeGalleySliderImageZeppoli}
                        alt="Zeppoli gallery image"
                        className="w-100 h-100"
                        loading="lazy"
                      />
                    </div>
                    <div
                      className="gallery-content"
                      style={{ borderRadius: "12px" }}
                    >
                      <a
                        data-fancybox="gallery2"
                        href={winterTwoCakeGalleySliderImageZeppoli}
                        className="icon-btn popup-img"
                        name="Zeppoli gallery image"
                      >
                        <i className="fas fa-eye"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="gallery-card mx-2">
                    <div
                      className="gallery-img"
                      style={{ borderRadius: "12px" }}
                    >
                      <img
                        src={engagementThreeCakeGalleySliderImageZeppoli}
                        alt="Zeppoli gallery image"
                        className="w-100 h-100"
                        loading="lazy"
                      />
                    </div>
                    <div
                      className="gallery-content"
                      style={{ borderRadius: "12px" }}
                    >
                      <a
                        data-fancybox="gallery2"
                        href={engagementThreeCakeGalleySliderImageZeppoli}
                        className="icon-btn popup-img"
                        name="Zeppoli gallery image"
                      >
                        <i className="fas fa-eye"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </Slider>
            </Fancybox2>
          </div>
        </div>
      </section>
    </>
  );
}

export default GallerySlider;
